import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_humanities_architecture_blue/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-9248dc59af.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-a8aa9c871c.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-58ab55cb2c.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-f16193f771.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-13c95e519b.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-a081ec9b26.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-719fa2d29f.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-d1972a38dc.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-b51c113277.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-a7ce47d5d8.png'; };
